import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import styles from "./TirthDetail.module.scss";

import { SingleBanner, Loader } from "../../../library/common";
import { BlogContent, BlogTopBar } from "../../../library/component";
import MetaTag from "../../../library/meta";

import { axiosInstance } from "../../../services";

const TirthDetail = () => {
  const { id } = useParams();
  const {
    i18n: { language },
  } = useTranslation();
  const [tirthDetail, setTirthDetail] = useState("");
  const [loader, setLoader] = useState(true);
  const fetchTirthDetail = async (id) => {
    setLoader(true);
    try {
      const res = await axiosInstance.get(`/tirths/${id}`);

      if (res?.data) {
        var transformedData = {
          coverImage: res?.data?.coverImage ? res?.data?.coverImage : "",
          title: res?.data?.title ? res?.data?.title : "",
          shortDescription: res?.data?.shortDescription
            ? res?.data?.shortDescription
            : "",
          longDescription: res?.data?.longDescription
            ? res?.data?.longDescription
            : "",
          address: res?.data?.address ? res?.data?.address : "",
          district: res?.data?.district?.name || "",
          state: res?.data?.state?.name || "",
          locationLink: res?.data?.locationLink,
          country: res?.data?.country?.name || "",
          pincode: res?.data?.pincode ? res?.data?.pincode : "",
          metaTitle: res?.data?.metafields?.title || "",
          metaDescription: res?.data?.metafields?.description || "",

          relateds: [],
        };

        setTirthDetail(transformedData);
      }
    } catch (error) {
      console.error("Error fetching tirth details:", error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (!tirthDetail) {
      setLoader(true);
      fetchTirthDetail(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  if (loader) {
    return <Loader />;
  }

  return (
    <main className={styles.tirthcontainer}>
      {tirthDetail ? (
        <MetaTag
          title={
            tirthDetail?.title?.[language] ? tirthDetail?.title?.[language] : ""
          }
          shortDescription={
            tirthDetail?.shortDescription?.[language]
              ? tirthDetail?.shortDescription?.[language]
              : ""
          }
          img={tirthDetail?.bannerImage ? tirthDetail?.bannerImage : ""}
          url={tirthDetail?.url ? tirthDetail?.url : ""}
        />
      ) : null}
      <div className={styles.bannerWrapper}>
        <SingleBanner {...tirthDetail} />
        <BlogTopBar {...tirthDetail} path="tirth" />

        <BlogContent {...tirthDetail} />
      </div>
    </main>
  );
};
export default TirthDetail;
